<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-16 10:52:34
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-ccy.vue
 * @Description: 茶产业
-->
<template>
  <div class="ccy">
    <div class="content">
      <div class="subtitle">三产占比</div>
      <!-- 统计 -->
      <section class="sczb" v-loading="loading.ccy">
        <template v-if="!loading.ccy">
          <section class="cy yc">
            <i class="icon" />
            <section class="name">{{ ccy.sc_proportion[0].name }}</section>
              <span class="value" v-if="ccy.sc_proportion[0].percent === 0">{{ ccy.sc_proportion[0].percent }}</span>
              <ICountUp class="value" v-else :endVal="Number(ccy.sc_proportion[0].percent)" />
          </section>
          <section class="cy ec">
            <i class="icon" />
              <section class="name">{{ ccy.sc_proportion[1].name }}</section>
              <span class="value" v-if="ccy.sc_proportion[1].percent === 0">{{ ccy.sc_proportion[1].percent }}</span>
              <ICountUp class="value" v-else :endVal="Number(ccy.sc_proportion[1].percent)" />
          </section>
          <section class="cy sc">
            <i class="icon" />
              <section class="name">{{ ccy.sc_proportion[2].name }}</section>
              <span class="value" v-if="ccy.sc_proportion[2].percent === 0">{{ ccy.sc_proportion[2].percent }}</span>
              <ICountUp class="value" v-else :endVal="Number(ccy.sc_proportion[2].percent)" />
          </section>
        </template>
      </section>
      <div class="subtitle">融合趋势</div>
      <!-- 堆叠柱状图 -->
      <chart-bar class="qsrh" />
      <!-- 堆叠面积图-->
      <!-- <chart-area class="qsrh" /> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('company-profile', ['ccy', 'loading'])
  },
  methods: {
    ...mapActions('company-profile', ['getCCY'])
  },
  created () {
    this.getCCY()
  }
}
</script>

<style lang="scss">
.ccy {
  padding-top: 52px;
  .content {
    padding: 10px 25px;
    height: 100%;
    position: relative;
    .subtitle {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.8;
    }
    .sczb {
      display: flex;
      flex-direction: row;
      height: 50px;
      margin-top: 10px;
      margin-bottom: 10px;
      .cy {
        flex: 1;
        height: 100%;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          right: 10px;
          top: 0;
          width: 1px;
          height: 50px;
          background-image: url("/public/image/company-profile/icon/分割线@2x.png");
        }
        &:last-of-type::after {
          display: none;
        }
        .icon {
          position: absolute;
          left: 0px;
          top: 10px;
          width: 30px;
          height: 30px;
          background-size: cover;
        }
        .name {
          position: absolute;
          right: 16px;
          bottom: 0;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #a8e4e5;
        }
        .value {
          position: absolute;
          right: 27px;
          top: 0;
          font-size: 24px;
          font-family: Montserrat;
          font-weight: 400;
          color: #ffffff;
          position: absolute;
          &::after {
            font-size: 16px;
            content: "%";
          }
        }
      }
      .yc {
        .icon {
          background-image: url("/public/image/company-profile/icon/农业@2x.png");
        }
      }
      .ec {
        .icon {
          background-image: url("/public/image/company-profile/icon/工业@2x.png");
        }
      }
      .sc {
        .icon {
          background-image: url("/public/image/company-profile/icon/服务业@2x.png");
        }
      }
    }
    .qsrh {
      height: 206px;
      // width: 305px;
      margin: 0 auto;
      margin-top: 13px;
    }
  }
}
</style>
